export default "__VITE_ASSET__q6tf5Tem__"